import React, { useContext } from 'react'
import { Link as GatsbyLink, GatsbyLinkProps } from 'gatsby'
import {
  isExternalLink,
  localizeLink
} from '@toasttab/shared/src/utils/linkUtils'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { LANGUAGE_KEY } from '@toasttab/shared/src/@types/types'

type Props = GatsbyLinkProps<any> & { language?: string }

const Link = React.forwardRef<HTMLAnchorElement, Props>(
  ({ language, hrefLang, to, onClick, children, ...rest }, ref) => {
    const context = useContext(I18nextContext)
    const urlLanguage = language || context.language
    const link = localizeLink(to, language, context)

    if (rest.target === '_blank') {
      return (
        <a {...rest} href={link} rel='noopener noreferrer' target='_blank'>
          {children}
        </a>
      )
    }

    if (isExternalLink(link)) {
      return (
        <a {...rest} href={link}>
          {children}
        </a>
      )
    }
    return (
      // @ts-ignore
      <GatsbyLink
        {...rest}
        hrefLang={hrefLang || urlLanguage}
        innerRef={ref}
        to={link}
        onClick={(e) => {
          if (language) {
            localStorage.setItem(LANGUAGE_KEY, language)
          }
          if (onClick) {
            onClick(e)
          }
        }}
      >
        {children}
      </GatsbyLink>
    )
  }
)

export default Link
